// Mock data for Hero Impex website

export const companyInfo = {
  name: "Hero Impex India Private Limited",
  tagline: "Precision, Performance, Progress",
  description: "Expert Machining, Machine Building, Manufacturing & Marketing of Web Coating, Lamination, Converting, and Printing Machines",
  founder: "Mr. Raj Kumar Gupta",
  established: "1977",
  privateltd: "1997",
  experience: "45+",
  customers: "800+",
  countries: "20+",
  machinesDelivered: "5000+",
  address: "#No 40, Anna Industrial Estate, Mettukuppam, Vanagaram, Chennai 600095, Tamil Nadu, India",
  email: "heroiipl@gmail.com",
  phone: "+91-9884012741",
  whatsapp: "+91-7483375955",
  linkedin: "www.linkedin.com/in/puneet-gupta-519458123",
  website: "www.heroimpex.in",
  workingHours: "9 AM - 6 PM (Mon-Sat)",
  gst: "33AABCH0199K1ZK",
  iec: "0498028933",
  mission: "Design and manufacture Extra ability and Durability machines that exceed customer expectations; make machines totally operator friendly & maximum Automation.",
  vision: "To be the leading Global provider of innovative and high-quality machines in India & beyond, Revolutionizing the manufacturing industry by setting new standards in machinery excellence."
};

export const products = [
  {
    id: 1,
    name: "BOPP Tape Coating Machine",
    category: "Coating Machines",
    image: "/images/products/coating/bopp-tape-coating-machine.jpg",
    description: "High-speed BOPP tape coating machine designed for manufacturing self-adhesive tapes, masking tapes, and packaging tapes. Features precision coating technology with automatic tension control system and German-engineered components for consistent quality output.",
    applications: ["Self-Adhesive Tape Manufacturing", "Masking Tape Production", "Packaging Tape", "Double-Sided Tape", "Stationery Tape"],
    industries: ["Packaging Industry", "Stationery Manufacturing", "Adhesive Tape Production", "Converting Industry"],
    specifications: {
      "Coating Width": "500mm - 1600mm (customizable)",
      "Machine Speed": "Up to 200 m/min",
      "Coating Method": "Hot melt / Solvent / Water-based",
      "Unwinding Diameter": "Max 1000mm",
      "Rewinding Diameter": "Max 800mm",
      "Total Power": "35-50 KW",
      "Machine Dimensions": "12000mm x 3500mm x 2800mm"
    },
    features: [
      "Automatic tension control system",
      "PLC with touchscreen interface",
      "Precision coating head with doctor blade",
      "Hot air drying system",
      "Optional lamination attachment",
      "EPC (Edge Position Control)",
      "German quality components"
    ],
    seoKeywords: "BOPP tape coating machine, adhesive tape coating machine India, tape manufacturing machine, coating machine manufacturer"
  },
  {
    id: 2,
    name: "Automatic Slitter Rewinder",
    category: "Slitting Machines",
    image: "/images/products/slitting/turret-slitting-machine.jpg",
    description: "High-speed automatic slitter rewinder designed for precision slitting and rewinding of self-adhesive paper, films, and BOPP tapes. Features duplex turret winding for continuous operation with minimal downtime.",
    features: [
      "Operator-friendly machine with pre-settable counter and auto-stop",
      "Unwind unit with taper cones, lateral movement, and brake assembly",
      "Layon roller for quick air gap removal and noise reduction",
      "Razor blade / Air score knife slitting (material dependent)",
      "Duplex turret with two shafts per turret for continuous operation",
      "Push button turret movement and changeover system"
    ],
    applications: [
      "Self-adhesive paper slitting",
      "Crepe paper processing",
      "Polyester PVC packaging",
      "BOPP self-adhesive tape slitting"
    ],
    specs: {
      maxWebWidth: "740 - 1650mm",
      unwindReelDia: "4000 mts length / 30\"",
      rewindReelDia: "1000 mts",
      speed: "Up to 200 m/min",
      drive: "5 HP AC drive with VFD control",
      turretDrive: "1/2 HP independent drive"
    }
  },
  {
    id: 3,
    name: "Single Shaft Auto Slicer Machine",
    category: "Slicing Machines",
    image: "/images/products/slitting/single-shaft-auto-slicer.jpg",
    description: "Precision auto slicer machine with PLC programmable control for high-efficiency cutting of adhesive tape logs into small rolls. Features pneumatic knife feeding and automatic lubrication for neat cutting edges.",
    features: [
      "High cutting efficiency with precision width setup",
      "PLC programmable control for easy operation and maintenance",
      "Pneumatic knife feeding system",
      "Auto spraying for knife lubrication",
      "Circular knife cutting with step-less speed adjustment",
      "Cooling system for circular knife to prevent overheating"
    ],
    applications: [
      "BOPP tape slicing",
      "Adhesive tape log cutting",
      "Packaging tape small roll production",
      "Industrial tape finishing"
    ],
    specs: {
      minWidth: "3mm",
      paperTubeID: "75mm",
      maxCuttingDiameter: "100mm",
      cuttingSpeed: "3-10 pc/min",
      airPressure: "8 kg/cm²",
      totalPower: "7.5 kW",
      dimensions: "3000x1300x1500 mm"
    }
  },
  {
    id: 4,
    name: "Surface Type Slitter Rewinder",
    category: "Slitting Machines",
    image: "/images/products/slitting/drum-slitter-rewinder.jpg",
    description: "Versatile surface type slitter rewinder equipped with top-bottom circular knife for various materials. Features AC motor control with length counter for smooth speed reduction and easy maintenance.",
    features: [
      "Top-bottom circular knife for material versatility",
      "AC Motor Control with VFD",
      "Length counter with gear system for smooth speed reduction",
      "Easy maintenance design",
      "Suitable for various packaging materials",
      "Compact footprint for space efficiency"
    ],
    applications: [
      "Flexible packaging film slitting",
      "Laminated material processing",
      "Paper and foil converting",
      "General material slitting operations"
    ],
    specs: {
      maxWebWidth: "500 - 1650mm",
      unwindReelDia: "1 metre",
      rewindReelDia: "750mm",
      speed: "Up to 100 m/min",
      drive: "5 HP AC drive with VFD control",
      slittingMode: "Circular Knife (top-bottom)"
    }
  },
  {
    id: 5,
    name: "Cantilever Type Slitter Rewinder",
    category: "Slitting Machines",
    image: "/images/products/slitting/cantilever-slitting-machine.jpg",
    description: "Heavy-duty cantilever type slitter rewinder with shaftless unwinder for easy roll handling. Features pneumatic brake, web alignment, and duplex cantilever winding for efficient operation.",
    features: [
      "Shaftless type heavy-duty unwinder for easy loading",
      "Pneumatic brake system for precise tension control",
      "Web alignment system for consistent quality",
      "Pneumatic safety shutter for cantilever unloading",
      "Duplex cantilever winding capability",
      "VFD control for variable speed operation"
    ],
    applications: [
      "Heavy-duty film processing",
      "Large roll material handling",
      "Flexible packaging conversion",
      "Industrial material slitting"
    ],
    specs: {
      maxWebWidth: "1000 - 1650mm",
      unwindReelDia: "1 metre",
      rewindReelDia: "750mm",
      speed: "Up to 100 m/min",
      slittingMode: "Razor in Groove",
      windingType: "Duplex Cantilever"
    }
  },
  {
    id: 6,
    name: "Log Rewinding Machine (Turret Type)",
    category: "Rewinding Machines",
    image: "/images/products/rewinding-log-turret.jpg",
    description: "Advanced turret type log rewinding machine with air shaft system and EPC for precision rewinding. Features slip motor drive and integrated trimming device for waste handling.",
    features: [
      "Unwind tension control by air expansion friction pneumatic brake",
      "Air shaft rewinding with tension control",
      "EPC (Edge Position Control) for trim finished products",
      "Air shaft unwinding with adjustable width",
      "Slip motor as main drive for precise control",
      "Trimming and handling device for waste strip management"
    ],
    applications: [
      "Jumbo roll rewinding",
      "Tape log production",
      "Film winding operations",
      "Paper rewinding processes"
    ],
    specs: {
      effectiveWidth: "500 to 2000mm",
      mechanicalSpeed: "200 m/min",
      paperTubeID: "75mm",
      totalPower: "7.5 kW",
      dimensions: "4800x2000x1800 mm"
    }
  },
  {
    id: 7,
    name: "Automatic Micro Slitter Rewinder",
    category: "Slitting Machines",
    image: "/images/products/slitting/micro-slitter-rewinder.jpg",
    description: "Compact automatic micro slitter rewinder specifically designed for small runs of BOPP self-adhesive tapes. Ideal for producing narrow width tapes with automated turret movement.",
    features: [
      "Compact design for small production runs",
      "Automated turret movement system",
      "Pre-settable counter meter",
      "Suitable for narrow width tape production",
      "Easy operation and maintenance",
      "Space-efficient footprint"
    ],
    applications: [
      "Small run BOPP tape production",
      "Narrow width adhesive tape manufacturing",
      "Specialty tape production",
      "Low-volume tape converting"
    ],
    specs: {
      slittingWidth: "9 - 72mm",
      rewindingLength: "5 - 65 m",
      corePaper: "76mm OD",
      corePlastic: "25mm OD (domestic tape)",
      drive: "2 HP AC motor",
      turretDrive: "1/2 HP geared motor"
    }
  },
  {
    id: 8,
    name: "Dual Shaft Auto Slicer Machine",
    category: "Slicing Machines",
    image: "/images/products/slitting/two-shaft-auto-slicer.jpg",
    description: "Enhanced dual shaft auto slicer with PLC control for increased productivity. Features manual circular knife angle adjustment and cooling system for extended blade life.",
    features: [
      "Dual shaft configuration for higher output",
      "PLC programmable control system",
      "Pneumatic knife feeding with auto lubrication",
      "Manual adjustment for circular knife angle",
      "Step-less speed adjustment via frequency converter",
      "Circular knife cooling system"
    ],
    applications: [
      "High-volume tape slicing",
      "Adhesive tape production",
      "Packaging tape finishing",
      "Multi-roll tape cutting"
    ],
    specs: {
      minWidth: "3mm",
      paperTubeID: "75mm",
      maxCuttingDiameter: "100mm",
      cuttingSpeed: "3-10 pc/min",
      airPressure: "8 kg/cm²",
      totalPower: "7.5 kW",
      dimensions: "3000x1300x1500 mm"
    }
  },
  {
    id: 9,
    name: "Paper Core Cutting Machine",
    category: "Core Making Machines",
    image: "/images/products/core-making/core-cutter-machine.jpg",
    description: "Pneumatically operated paper core cutting machine for precision cutting of paper cores from 12mm to 76mm sizes. Essential ancillary equipment for tape manufacturing plants, ensuring clean, burr-free core edges for perfect roll winding.",
    features: [
      "Pneumatically controlled cutter shaft for precision cutting",
      "Cuts paper cores in sizes from 12mm to 76mm",
      "Clean, burr-free cutting edges",
      "Robust heavy-duty fabricated structure",
      "Fully automatic version with pneumatic core ejection available",
      "Low maintenance and operator-friendly design"
    ],
    applications: [
      "BOPP tape core preparation",
      "Masking tape core cutting",
      "Label and paper roll cores",
      "Tape manufacturing plant ancillary"
    ],
    specs: {
      coreSizes: "12mm - 76mm",
      maxWebWidth: "500mm",
      coreDiameter: "Up to 76mm",
      drive: "2 HP AC motor",
      operation: "Pneumatic cutter shaft"
    },
    seoKeywords: "paper core cutting machine, core cutter machine India, tape core cutting machine, automatic core cutting machine manufacturer"
  },
  {
    id: 10,
    name: "Automatic Core Loader Machine",
    category: "Core Making Machines",
    image: "/images/products/core-making/core-loader-machine.jpg",
    description: "Automatic core loading machine designed to load paper cores onto rewinding shafts quickly and accurately. Reduces changeover time and manual handling in slitting and rewinding operations, boosting overall plant productivity.",
    features: [
      "Automatic core positioning and loading onto shafts",
      "Pneumatically operated loading mechanism",
      "Reduces changeover time between rewinding cycles",
      "Handles multiple core widths in a single cycle",
      "Eliminates manual core handling errors",
      "Seamless integration with slitter rewinders"
    ],
    applications: [
      "Slitter rewinder core loading",
      "BOPP tape plant automation",
      "High-volume converting lines",
      "Tape manufacturing plant ancillary"
    ],
    specs: {
      coreSizes: "25mm - 76mm ID",
      operation: "Pneumatic loading system",
      compatibility: "All Hero Impex slitter rewinders",
      airPressure: "6-8 kg/cm²"
    },
    seoKeywords: "core loader machine, automatic core loading machine India, slitter rewinder core loader, tape plant automation equipment"
  },
  {
    id: 11,
    name: "Rotogravure & Flexo Printing Machine",
    category: "Printing Machines",
    image: "/images/products/printing/flexo-printing-machine.jpg",
    description: "Heavy-duty multi-purpose rotogravure and flexographic printing machines for film, foil, paper, lamination, and coating applications. Available from 1 to 10 colour printing stations with precision registration and heavy-duty perforated structure.",
    features: [
      "1 to 10 colour printing configurations",
      "Reverse printing attachment",
      "VFD control panel for drive and drying system",
      "Web aligning system for accurate registration",
      "Two/three roll registration on heavy-duty structure",
      "Optional unwind/rewind turret with splicing",
      "Optional ink circulation and synchronised electronic tension control"
    ],
    applications: [
      "Film and foil printing",
      "Paper and lamination printing",
      "Printed BOPP tape production",
      "Flexible packaging printing"
    ],
    specs: {
      workingWidth: "300mm - 1650mm",
      colours: "1 to 10 colours",
      printingType: "Rotogravure / Flexographic",
      drive: "VFD controlled",
      registration: "Two/three roll system"
    },
    seoKeywords: "rotogravure printing machine India, flexo printing machine manufacturer, tape printing machine, film printing machine Chennai"
  },
  {
    id: 12,
    name: "Doctor Rewinding Machine (Salvage Rewinder)",
    category: "Rewinding Machines",
    image: "/images/products/rewinding-doctor-machine.jpg",
    description: "Compact doctor rewinding machine for salvage recovery of rolls with joints, telescopic rolls, or rejected material. Fitted with pre-settable counter meter with auto-stop for accurate rewinding length every time.",
    features: [
      "Salvage recovery of joined, telescopic or rejected rolls",
      "Pre-settable counter meter with auto-stop",
      "Mechanical clutch controlled rewinding tension",
      "Compact tabletop-friendly footprint",
      "Simple single-operator design",
      "Low power consumption"
    ],
    applications: [
      "Roll inspection and doctoring",
      "Salvage recovery of rejected rolls",
      "Rejoining and length correction",
      "Small roll rewinding"
    ],
    specs: {
      maxWebWidth: "100mm",
      coreDiameter: "76mm",
      drive: "1 HP AC motor",
      rewinding: "Mechanical clutch",
      counter: "Pre-settable with auto-stop"
    },
    seoKeywords: "doctor rewinding machine, salvage rewinder India, inspection rewinding machine, tape roll doctoring machine"
  },
  {
    id: 13,
    name: "Shrink Wrapping Machine (Shrink Pack Tunnel)",
    category: "Packaging Machines",
    image: "/images/products/misc/shrink-wrapping-machine.jpg",
    description: "Powerful shrink pack tunnel for mid to high production packaging of finished tape rolls. Operator-friendly machine with conveyor feeding that speeds up any shrink packaging process simply and efficiently.",
    features: [
      "Conveyor-fed shrink pack tunnel",
      "Handles mid to high production schedules",
      "Uniform heat distribution for perfect shrink finish",
      "Adjustable temperature control panel",
      "Castor wheels for easy mobility",
      "Operator-friendly and low maintenance"
    ],
    applications: [
      "BOPP tape roll packaging",
      "Finished roll shrink wrapping",
      "Multi-roll bundle packing",
      "Retail-ready tape packaging"
    ],
    specs: {
      tunnelSize: "1m L x 730mm W x 430mm H",
      tunnelDrive: "1 HP motor with gearbox",
      conveyorDrive: "1/2 HP motor",
      feeding: "Conveyor type"
    },
    seoKeywords: "shrink wrapping machine India, shrink pack tunnel manufacturer, tape roll packaging machine, shrink tunnel Chennai"
  },
  {
    id: 14,
    name: "Four Shaft Auto Slicer Machine",
    category: "Slicing Machines",
    image: "/images/products/slitting/four-shaft-auto-slicer.jpg",
    description: "High-output four shaft auto slicer with PLC programmable control for maximum productivity in tape log cutting. Four shaft configuration allows continuous loading and cutting cycles, delivering the highest throughput in the auto slicer range.",
    features: [
      "Four shaft configuration for maximum output",
      "PLC programmable control with touchscreen",
      "Pneumatic knife feeding with auto spray lubrication",
      "High precision cutting with freely settable widths",
      "Step-less speed adjustment via frequency converter",
      "Circular knife cooling system for extended blade life"
    ],
    applications: [
      "Mass production tape slicing",
      "BOPP and PVC insulation tape cutting",
      "High-volume converting plants",
      "Multi-shift continuous operation"
    ],
    specs: {
      minWidth: "3mm",
      paperTubeID: "75mm",
      maxCuttingDiameter: "100mm",
      cuttingSpeed: "3-10 pc/min per shaft",
      airPressure: "8 kg/cm²",
      shafts: "4 working shafts"
    },
    seoKeywords: "four shaft auto slicer machine, 4 shaft tape cutting machine India, high output tape log slicer, automatic tape slicing machine manufacturer"
  },
  {
    id: 15,
    name: "Manual Slicing Machine",
    category: "Slicing Machines",
    image: "/images/products/slitting/manual-slicer-machine.jpg",
    description: "Compact, operator-friendly manual slicing machine for high-speed precision slicing of paper cores and log rolls of self-adhesive tapes. A cost-effective entry point for tape converting with optional rewinding and lamination attachments.",
    features: [
      "High-speed precision slicing of log rolls and paper cores",
      "Hand wheel operated carriage with lead screw for accurate width setting",
      "Compact, operator-friendly design",
      "Optional rewinding attachment (jumbo to log to market rolls)",
      "Optional rewinding/lamination attachment",
      "Low investment and minimal maintenance"
    ],
    applications: [
      "Self-adhesive tape log slicing",
      "Paper core slicing",
      "Small-scale tape converting",
      "Jumbo to market roll conversion (with attachment)"
    ],
    specs: {
      maxWebWidth: "500 - 1650mm",
      reelDia: "Up to 1000 mts",
      drive: "2 HP AC motor with starter",
      operation: "Manual hand wheel carriage"
    },
    seoKeywords: "manual slicing machine, manual tape log cutter India, hand operated slicer machine, low cost tape cutting machine"
  },
  {
    id: 16,
    name: "Rewinder Cum Slicer Machine",
    category: "Slicing Machines",
    image: "/images/products/slitting/rewinder-cum-slicer.jpg",
    description: "Versatile 2-in-1 rewinder cum slicer that converts jumbo rolls to log rolls and slices them into market-ready rolls on a single machine. Ideal for small and medium tape plants looking to maximise output per square foot.",
    features: [
      "Combined rewinding and slicing in one machine",
      "Converts jumbo rolls to log rolls to market rolls",
      "Optional lamination attachment for substrate bonding",
      "Pneumatic roll clamping for safe operation",
      "Precision width setting with lead screw carriage",
      "Space-saving footprint for compact plants"
    ],
    applications: [
      "Jumbo to market roll conversion",
      "Tape log rewinding and slicing",
      "Lamination and slicing in one pass",
      "Compact tape manufacturing setups"
    ],
    specs: {
      maxWebWidth: "500 - 1650mm",
      reelDia: "Up to 1000 mts",
      drive: "2 HP AC motor with starter",
      functions: "Rewinding + Slicing (+ optional lamination)"
    },
    seoKeywords: "rewinder cum slicer machine, rewinding and slicing machine India, 2 in 1 tape converting machine, jumbo roll to market roll machine"
  }
];

export const services = [
  {
    id: 1,
    title: "Machine Installation",
    description: "Professional installation services with complete setup and calibration by our expert engineers. We ensure proper commissioning and operator training for smooth production start-up.",
    details: [
      "Site survey and preparation guidance",
      "Complete mechanical and electrical installation",
      "Precision calibration and testing",
      "Comprehensive operator training",
      "Documentation and operation manuals"
    ],
    icon: "wrench"
  },
  {
    id: 2,
    title: "After Sales Support",
    description: "Comprehensive after-sales support keeping your industrial machinery fully operational. We repair various equipment including conveyor systems, packaging, and production machinery.",
    details: [
      "24/7 phone and email support",
      "Remote diagnostics and troubleshooting",
      "On-site emergency repair services",
      "Priority response for critical issues",
      "Regular follow-up and maintenance scheduling"
    ],
    icon: "headset"
  },
  {
    id: 3,
    title: "Spare Parts Guarantee",
    description: "Guarantee of original replacement parts with critical components in stock. Delivered within 24 hours across India to minimize production downtime.",
    details: [
      "Original OEM replacement parts only",
      "Critical parts maintained in stock",
      "24-hour delivery commitment",
      "Warranty coverage on all parts",
      "Technical installation support"
    ],
    icon: "package"
  },
  {
    id: 4,
    title: "Technical Support & Training",
    description: "Extensive training and guidance with latest technical knowledge. Our experts provide comprehensive support leveraging 45+ years of manufacturing expertise.",
    details: [
      "Operator training programs",
      "Maintenance technician training",
      "Process optimization consultation",
      "Troubleshooting guidance",
      "Technical documentation support"
    ],
    icon: "clipboard"
  },
  {
    id: 5,
    title: "Maintenance Services",
    description: "Regularly scheduled service with routine checks, scheduled and emergency repairs, and replacement or realignment of parts to keep machines running optimally.",
    details: [
      "Preventive maintenance programs",
      "Scheduled routine inspections",
      "Emergency repair services",
      "Parts replacement and alignment",
      "Performance optimization checks"
    ],
    icon: "settings"
  },
  {
    id: 6,
    title: "Turn-Key Project Solutions",
    description: "Complete turn-key project establishment from concept to commissioning. Custom machinery solutions tailored to your specific production requirements.",
    details: [
      "Project consultation and planning",
      "Custom machine design and development",
      "Factory layout optimization",
      "Complete installation and commissioning",
      "Post-installation support and training"
    ],
    icon: "cpu"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "45+ Years Experience",
    description: "Established in 1977, we bring over four decades of expertise in coating and converting machinery. Founded by professional mechanical engineer with West German company experience.",
    stat: "45+",
    label: "Years"
  },
  {
    id: 2,
    title: "800+ Satisfied Clients",
    description: "Trusted by leading manufacturers across India and 20+ countries worldwide including USA, UK, Gulf countries, Africa, and Indian subcontinent.",
    stat: "800+",
    label: "Clients"
  },
  {
    id: 3,
    title: "5000+ Machines Delivered",
    description: "Successfully installed and commissioned thousands of machines with proven reliability. Machines performing excellently in over 20 countries.",
    stat: "5000+",
    label: "Machines"
  },
  {
    id: 4,
    title: "German Engineering Standards",
    description: "Machines built following German pattern in construction, raw material selection, processing, and testing. Emphasis on durability and precision.",
    stat: "100%",
    label: "Quality"
  },
  {
    id: 5,
    title: "Complete Customization",
    description: "Flexible customization options and turn-key project solutions to meet your specific production requirements and operational needs.",
    stat: "Custom",
    label: "Solutions"
  },
  {
    id: 6,
    title: "Maximum Automation",
    description: "Machines designed for operator-friendliness with maximum automation. PLC-based controls and advanced features for enhanced productivity.",
    stat: "Auto",
    label: "Control"
  }
];

export const companyHistory = [
  { year: "1977", event: "Company Conceived and Developed", description: "Founded by Mr. Raj Kumar Gupta to substitute imports for coating, printing, and converting industry" },
  { year: "1978", event: "Ancillary Converting Machines", description: "Launched production of ancillary converting equipment" },
  { year: "1981", event: "One Time Carbon Manufacturing Plant", description: "Developed specialized carbon paper manufacturing systems" },
  { year: "1984", event: "Typewriter & Carbon Paper Plant", description: "Introduced handwriting and plastic impregnated carbon paper manufacturing plant" },
  { year: "1986", event: "Paper Based Packaging Tape Plant", description: "Entered paper-based packaging tape manufacturing equipment segment" },
  { year: "1990", event: "Film Based Self Adhesive Tape Plant", description: "Pioneered film-based packaging self-adhesive tape manufacturing solutions" },
  { year: "1992", event: "Carbonless (NCR) Paper Plant", description: "Developed carbonless paper manufacturing systems" },
  { year: "1993", event: "Export Drive Launched", description: "First OPP Coating and Converting Line project exported to Middle East" },
  { year: "1997", event: "Private Limited Company", description: "Incorporated as Hero Impex India Private Limited" },
  { year: "1998", event: "Hot Melt Polycoating Machine", description: "Introduced hot melt polycoating technology" },
  { year: "2002", event: "High Speed BOPP/OPP Coating Line", description: "Developed and exported high-speed coating lines" },
  { year: "2005", event: "Fully Automatic PVC Insulation Tape Plant", description: "Launched fully automatic PVC tape manufacturing systems" },
  { year: "2007", event: "Special Purpose Hot Melt Machine", description: "Special purpose hot melt coating & lamination machine developed" },
  { year: "2010", event: "PLC Based Auto Slicer", description: "Introduced PLC-based automatic slicing for tape industry" },
  { year: "2012", event: "Fully Automatic Conversion Plant", description: "Developed and exported fully automatic conversion plant for self-adhesive tapes" },
  { year: "2016", event: "Fully Automatic Packaging Tape Plant", description: "Launched comprehensive packaging tape manufacturing solutions" },
  { year: "2019", event: "Advanced Paper Slitting Machine", description: "Paper slitting and rewinding machine developed for USA client" },
  { year: "2022", event: "Redeveloped Paper Coating Machines", description: "Enhanced paper coating machines for various applications" },
  { year: "2026", event: "Continued Innovation", description: "Leading manufacturer with 5000+ installations across 20+ countries" }
];

export const testimonials = [
  {
    id: 1,
    industry: "Packaging Industry",
    location: "Dubai, UAE",
    text: "We purchased a BOPP tape coating machine three years ago. The machine quality is exceptional and their after-sales support is outstanding. Highly recommended for serious manufacturers.",
    rating: 5,
    icon: "package"
  },
  {
    id: 2,
    industry: "Film Manufacturing",
    location: "Mumbai, India",
    text: "These machines have helped us expand our production capacity significantly. The German engineering quality combined with competitive pricing gives us the perfect advantage.",
    rating: 5,
    icon: "film"
  },
  {
    id: 3,
    industry: "Converting Industry",
    location: "Middle East",
    text: "The slitting rewinding machine we bought exceeded our expectations. Precision cutting, easy operation, and excellent ROI. The installation team was very professional.",
    rating: 5,
    icon: "cog"
  },
  {
    id: 4,
    industry: "Adhesive Tape Manufacturing",
    location: "Southeast Asia",
    text: "Working with Hero Impex has been a great experience. They understood our requirements and delivered a customized solution. The machine runs smoothly with minimal maintenance.",
    rating: 5,
    icon: "wrench"
  }
];

export const globalPresence = [
  { name: "Bangladesh", lat: 23.685, lng: 90.3563 },
  { name: "India", lat: 20.5937, lng: 78.9629 },
  { name: "UAE", lat: 23.4241, lng: 53.8478 },
  { name: "Oman", lat: 21.4735, lng: 55.9754 },
  { name: "Saudi Arabia", lat: 23.8859, lng: 45.0792 },
  { name: "Sri Lanka", lat: 7.8731, lng: 80.7718 },
  { name: "Syria", lat: 34.8021, lng: 38.9968 },
  { name: "USA", lat: 37.0902, lng: -95.7129 },
  { name: "Egypt", lat: 26.8206, lng: 30.8025 },
  { name: "Iran", lat: 32.4279, lng: 53.6880 },
  { name: "Jordan", lat: 30.5852, lng: 36.2384 },
  { name: "Kuwait", lat: 29.3117, lng: 47.4818 },
  { name: "Nepal", lat: 28.3949, lng: 84.1240 },
  { name: "Qatar", lat: 25.3548, lng: 51.1839 },
  { name: "Turkey", lat: 38.9637, lng: 35.2433 },
  { name: "Ethiopia", lat: 9.145, lng: 40.4897 },
  { name: "Thailand", lat: 15.8700, lng: 100.9925 },
  { name: "Tanzania", lat: -6.369, lng: 34.888 },
  { name: "Malawi", lat: -13.254, lng: 34.301 },
  { name: "Africa", lat: -8.7832, lng: 34.5085 }
];
